import _ from 'underscore';

export const getBulkEditService = ({ dataStore: DataStore }) => {
  if (!DataStore) {
    return {};
  }
  const pollStatus = (taskId, successCb, failedCb) => {
    DataStore.BulkEditSession.find(taskId, { cacheResponse: false }).then((response) => {
      successCb(response);
    })
      .catch(failedCb);
  };

  const processResponse = (completeCB, failedCB, progressCB, response) => {
    if (_.contains(['Completed', 'CompletedWithErrors'], response.Status)) {
      completeCB(response);
    } else if (_.contains(['Failed', 'Aborted', 'Expired'], response.Status)) {
      failedCB(response);
    } else { // task is inprogress or pending
      progressCB(response);
      setTimeout(
        _.partial(
          pollStatus,
          response.Id,
          _.partial(processResponse, completeCB, failedCB, progressCB),
          failedCB
        ),
        500
      );
    }
    return response;
  };

  /*
   * @param {Object} options
   * @param {Object} options.params
   * @param {function} options.progressCB
   * @param {function} options.completeCB
   * @param {function} options.failedCB
   * @param {boolean} preview
   */
  const bulkEdit = ({
    params,
    completeCB = _.noop,
    failedCB = _.noop,
    progressCB = _.noop,
  }, preview = false) => {
    const process = preview ?
      _.identity :
      _.partial(processResponse, completeCB, failedCB, progressCB);
    const urlParameters = { $expand: 'BulkEditResults' };

    if (preview) {
      urlParameters.preview = true;
    }
    return DataStore.BulkEditSession
      .create(params, {
        urlParameters,
        cacheResponse: false,
      })
      .then(process)
      .catch(failedCB);
  };

  const save = options => bulkEdit(options);
  const preview = options => bulkEdit(options, true);

  return {
    bulkEditService: {
      save,
      preview,
    },
  };
};
